<template>
    <div class="__em-selectlist">
        <!-- <mt-field :label="model.caption" :value="selectedDisplayValue" :readonly="param.readonly" v-if="param.readonly" :titlewidth="titlewidth" :value-align="textalign"></mt-field> -->
        <mt-cell :title="model.caption" :readonly="param.readonly" v-if="param.readonly" :titlewidth="titlewidth" :value-align="textalign">
            <div class="em-select-value mt-color-grey-lv3">
                <template>{{selectedDisplayValue}}</template>
            </div>
        </mt-cell>
        <mt-cell :title="model.caption" @click.native="handleClick" is-link :disabledcolor="param.disabled" :required="param.required" v-if="!param.readonly" :titlewidth="titlewidth" :value-align="textalign">
            <div :class="[{'mt-color-grey-lv3':selectedDisplayValue ==='请选择' }]">{{selectedDisplayValue}}</div>
        </mt-cell>
        
        <mt-popup v-model="popupVisible" position="bottom" v-if="!param.readonly" :pid="pid">
            <mt-picker :columns="pickerOptions" :visible-item-count="1" :show-toolbar="true" @confirm="handleConfirm" @cancel="handleCancel" value-key="label" :title="model.caption" ref="picker" @change="handleChange"></mt-picker>
            <mt-box-group v-model="currentValue" v-if="selectType === 'multi-select'" class="__em-selectlist-group">
                <mt-cell-group>
                    <mt-checkbox align="right" :name="item.value" :disabled="item.disabled" v-for="item in convertOptions" :key="item.value">
                        {{item.label}}
                    </mt-checkbox>
                </mt-cell-group>
            </mt-box-group>
        </mt-popup>
    </div>
</template>
<script>
export default {

    name: 'emSelectlist',

    props: {
        model: {
            type: Object,
            default: function() {
                return {};
            }
        },
        value: { default: '' },
        displayValue: { default: '' },
        options: {
            type: Array,
            default: function() {
                return [];
            }
        },
        titlewidth:{
            type: String,
            default: function() {
                return '';
            }
        },
        textalign:{
            type: String,
            default: function() {
                return '';//flex-start
            }
        },
        pid:{
            type: String,
            default: function() {
                return null;
            }
        }
    },

    data() {
        return {
            currentValue: this.getCurrentValue(this.value),
            popupVisible: false
        };
    },

    computed: {
        selectType() {
            if (this.model.xtype === 'radiolist') {
                return 'select';
            }
            if (this.model.xtype === 'checkboxlist') {
                return 'multi-select';
            }
        },
        convertOptions() {
            return this.options.map((opt) => {
                return {
                    label: opt.name,
                    value: opt.id,
                    disabled: this.param.disabled
                };
            });
        },
        pickerOptions() {
            if (this.selectType === 'multi-select') {
                return;
            }
            let index = 0;
            let val = this.currentValue;
            this.convertOptions.some((item, i) => {
                if (item.value === val) {
                    index = i;
                    return true;
                }
            });
            return [{
                defaultIndex: index,
                values: this.convertOptions
            }];
        },
        param() {
            return this.model.initParam;
        },
        selectedDisplayValue() {
            let currentValue = this.value;
            if (currentValue) {
                if (!this.options.length) {
                    return this.displayValue;
                }
                let displays = [];
                let vals = currentValue.split(',');
                this.options.forEach((item) => {
                    vals.forEach(function(v) {
                        if (v === item.id) {
                            displays.push(item.name);
                        }
                    });
                });
                return displays.join(',') || this.displayValue;
            }
            if (!this.param.readonly) {
                return this.placeholder;
            }
            return this.displayValue;
        },
        placeholder() {
            return this.param.placeholder || '请选择';
        }
    },

    watch: {
        value(val) {
            if (!this._isValueEqual()) {
                this.currentValue = this.getCurrentValue(val);
            }
            this.$emit('update:displayValue', this.selectedDisplayValue);
        },
        popupVisible(val) {
            if (val === false) {
                if (!this._isValueEqual()) {
                    //如果用户没有点击确定，重置勾选状态
                    this.currentValue = this.getCurrentValue(this.value, this.selectType);
                }
            }
        }
    },

    methods: {
        _isValueEqual() {
            if (this.selectType === 'select') {
                return this.value === this.currentValue;
            }
            return this.value === this.currentValue.join(',');
        },
        getCurrentValue(val) {
            if (this.model.xtype === 'radiolist') {
                return val;
            } else {
                if (!val) { return []; }
                return val.split(',');
            }
        },
        handleClick() {
            if (this.param.disabled || this.param.readonly) {
                return;
            }
            this.popupVisible = true;
        },
        handleConfirm() {
            if (this.selectType === 'select') {
                this.$emit('input', this.currentValue);
            } else {
                this.$emit('input', this.currentValue.join(','));
            }
            this.popupVisible = false;
        },
        handleCancel() {
            this.popupVisible = false;
        },
        handleChange() {
            let pickerVal = this.$refs.picker.getValues()[0];
            if (pickerVal) {
                this.currentValue = pickerVal.value;
            }
        }
    }
};
</script>
<style lang="css">
.__em-selectlist .mint-picker-column__frame {
    position: absolute;
}

.__em-selectlist .__em-selectlist-group {
    max-height: 250px;
    overflow: auto;
}
</style>


// WEBPACK FOOTER //
// emSelectlist.vue?0ec17711